import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";

import {Item, Label} from "semantic-ui-react";

import {Project} from "../../models/project";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {ProjectTypeIcon} from "./project-type-icon";
import {Municipality} from "../../models/municipality";
import moment from "moment";
import {Icon} from "../../core/components/icon/icon";
export interface ProjectItemProps {
    project: Project;
    auftragsverwaltung: Auftragsverwaltung;
    handleShowProject: (project: Project) => void;
}

@observer
export class ProjectItem extends Component<ProjectItemProps, any> {
    constructor(props: ProjectItemProps) {
        super(props);
        this.state = {
            typeCodes: null
        };
    }

    componentDidMount(): void {
        this.loadDomains();
    }

    render(): React.ReactElement | null {
        const {
            auftragsverwaltung,
            project,
            handleShowProject
        } = this.props;

        const {typeCodes} = this.state;

        if (!project) {
            return null;
        }

        return (
            <Item className="project-item" onClick={(event: React.MouseEvent) => {
                event.preventDefault();
                handleShowProject(project);
            }}>
                <ProjectTypeIcon auftragsverwaltung={auftragsverwaltung} typeId={project.typeId} />
                <Item.Content>
                    <Item.Header as={"h4"}>{project.name}</Item.Header>
                    <Item.Meta>
                        <span className="guid">{project.id}</span>
                        {project.process?.isClosed &&
                            <span className="closed-at">
                                <Icon name="signal_flag_checkered"/>
                                { project.closedOn ?
                                    moment(project.closedOn).format("DD.MM.YYYY, HH:mm") :
                                    undefined }
                            </span>
                        }
                    </Item.Meta>
                    <Item.Description>
                        {project.reason}
                    </Item.Description>
                    <Item.Extra>
                        <Label basic color="blue">{typeCodes?.get(project.typeId)}</Label>
                        <Label icon="user circle" content={project.contractor?.displayName} />
                        {project.municipalities?.map((m: Municipality) => (
                            <Label
                                basic
                                key={m.bfsNr}
                                content={m.name} />
                        ))}
                        <span className="last-updated">
                            <Icon name="pencil"/>
                            {moment(project.updatedAt).format("DD.MM.YYYY, HH:mm")}
                        </span>
                    </Item.Extra>
                </Item.Content>
            </Item>
        );
    }

    /**
     * Load domains
     *
     * @private
     */
    private loadDomains() {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.getShortDomainCodes("project", "typeId").then((typeCodes) => {
            this.setState({
                typeCodes
            });
        });
    }
}
